export const SITE_NOT_EMPTY_SENDBACKRESULT_DUMMY = {
  'data': {
    'name': 'Site Name' + Math.floor(Math.random() * 1000) + 1,
    'externalID': '132A',
    'cultures': ['fr-BE', 'nl-BE'],
    'timeZone': 'Etc/GMT+12',
    'subscriptions': [],
    'addresses': [
      {
        'address':  {
          'name': 'test ad',
          'line1': 'test ad site',
          'line2': 'test ad',
          'line3': 'test ad',
          'zip': 'test ad',
          'city': 'test ad',
          'state': 'test ad',
          'country': 'Spain',
          'countryCode': 'lu',
        }
      }
    ],
    'contacts': [
      {
        'type': 'default',
        'contact': {
          'name': 'contact 1',
          'surname': 'sur contact',
          'culture': 'nl-BE',
          'email': 'contact@storever.com',
          'phone': '02544266',
          'mobile': '047624454',
          'skype': 'skype@skype.com',
          'address': {
            'name': 'test ad',
            'line1': 'test ad',
            'line2': 'test ad',
            'line3': 'test ad',
            'zip': 'test ad',
            'city': 'test ad',
            'state': 'test ad',
            'country': 'test ad'
          },
          'department': 'sales',
          'sex': 'M',
          'typeUser': 'typeUser',
          'comments': ''
        }
      }
    ],
    'network': {
      'status': true,
      'ipAddress': {
        'isDhcp': true
      },
      'wifi': {   'enable': false,    },
      'proxy': {  'enable': false    },
      'server': 'PRX1810-000004'
    },
    'comment': 'comment aaa aaa',
    'deleted': false,
    'server': null
  },
  'log': null,
  'message': null,
  'statusCode': 0,
  'version': '1.0.1.18'
};
export const ORDERS_STAT_SENDBACKRESULT_DUMMY = {
  'data': {
    array: [
      {'date': '2021-04-01T00:00:00+00:00', 'deploy': 3 , 'exchange': 1, 'sum': 4},
      {'date': '2021-04-02T00:00:00+00:00', 'deploy': 3 , 'exchange': 3, 'sum': 6},
      {'date': '2021-04-03T00:00:00+00:00', 'deploy': 7 , 'exchange': 8, 'sum': 15},
      {'date': '2021-04-04T00:00:00+00:00', 'deploy': 9 , 'exchange': 9, 'sum': 18},
      {'date': '2021-04-05T00:00:00+00:00', 'deploy': 4 , 'exchange': 3, 'sum': 8},
      {'date': '2021-04-06T00:00:00+00:00', 'deploy': 7 , 'exchange': 4, 'sum': 11},
      {'date': '2021-04-07T00:00:00+00:00', 'deploy': 5 , 'exchange': 5, 'sum': 10},
      {'date': '2021-04-08T00:00:00+00:00', 'deploy': 3 , 'exchange': 6, 'sum': 9},
      {'date': '2021-04-09T00:00:00+00:00', 'deploy': 2, 'exchange': 7, 'sum': 9},
      {'date': '2021-04-10T00:00:00+00:00', 'deploy': 1 , 'exchange': 8, 'sum': 9},
      {'date': '2021-04-11T00:00:00+00:00', 'deploy': 9 , 'exchange': 9, 'sum': 18},
      {'date': '2021-04-12T00:00:00+00:00', 'deploy': 8 , 'exchange': 10, 'sum': 18},
      {'date': '2021-04-13T00:00:00+00:00', 'deploy': 7 , 'exchange': 11, 'sum': 18},
      {'date': '2021-04-14T00:00:00+00:00', 'deploy': 5 , 'exchange': 12, 'sum': 17},
      {'date': '2021-04-15T00:00:00+00:00', 'deploy': 4 , 'exchange': 13, 'sum': 17},
      {'date': '2021-04-16T00:00:00+00:00', 'deploy': 3 , 'exchange': 1, 'sum': 4},
      {'date': '2021-04-17T00:00:00+00:00', 'deploy': 2 , 'exchange': 2, 'sum': 4},
      {'date': '2021-04-18T00:00:00+00:00', 'deploy': 1 , 'exchange': 3, 'sum': 4},
      {'date': '2021-04-19T00:00:00+00:00', 'deploy': 11 , 'exchange': 4, 'sum': 15},
      {'date': '2021-04-20T00:00:00+00:00', 'deploy': 12 , 'exchange': 5, 'sum': 17},
      {'date': '2021-04-21T00:00:00+00:00', 'deploy': 13 , 'exchange': 6, 'sum': 19},
      {'date': '2021-04-22T00:00:00+00:00', 'deploy': 14 , 'exchange': 7, 'sum': 21},
      {'date': '2021-04-23T00:00:00+00:00', 'deploy': 15 , 'exchange': 8, 'sum': 22},
      {'date': '2021-04-24T00:00:00+00:00', 'deploy': 1 , 'exchange': 9, 'sum': 10},
      {'date': '2021-04-25T00:00:00+00:00', 'deploy': 2 , 'exchange': 10, 'sum': 12},
      {'date': '2021-05-26T00:00:00+00:00', 'deploy': 3 , 'exchange': 11, 'sum': 13},
      {'date': '2021-05-27T00:00:00+00:00', 'deploy': 4 , 'exchange': 12, 'sum': 16},
      {'date': '2021-05-28T00:00:00+00:00', 'deploy': 5 , 'exchange': 13, 'sum': 18},
      {'date': '2021-06-29T00:00:00+00:00', 'deploy': 6 , 'exchange': 14, 'sum': 20},
      {'date': '2021-07-30T00:00:00+00:00', 'deploy': 7 , 'exchange': 15, 'sum': 22},
    ],
    count: 30
  },
  log: null,
  message: null,
  statusCode: 0,
  version: '1.0.1.18',
  'timeToProcess': 'string',
  'cached': false
};
//
// export const SUBSCRIPTION = {
//   'tags': null,
//   'players': [ {
//     'productID': 1,
//     'productName': 'MM-Box Audio',
//     'deviceID': 'mmb0406-000091',
//     'deviceModel': 'Dell Optiplex GX520 DT',
//     'deviceFirmware': '2.0.3454.25996',
//     'deviceImage': 'product_3.jpg',
//     'deviceMacAddress': null,
//     'isDefault': true,
//     'lastConnection': '0001-01-01T00:00:00',
//     'created': '2019-11-19T13:58:05.807+01:00',
//     'updated': '2019-11-19T13:58:05.807+01:00',
//     'id': 300121,
//     'name': 'mmb0406-000091',
//     'displayName': 'mmb0406-000091'
//   }],
//   'product': {
//     'audio': true,
//     'video': false,
//     'portalRights': {
//       'showPlanning': true,
//       'showPlaylist': true,
//       'showPlayLogs': false,
//       'showEventLogs': true,
//       'showCommandLogs': false,
//       'showScheduledMessages': true,
//       'showUpdateServer': true,
//       'showLogsOnServer': false
//     },
//     'id': 1,
//     'name': 'MM-Box Audio',
//     'displayName': 'MM-Box Audio'
//   },
//   'service': {
//     'id': 1,
//     'name': 'Audio',
//     'displayName': 'Audio'
//   },
//   'type': 'Audio',
//   'cultures': [
//     'fr-FR'
//   ],
//   'comments': '2019-12-30 11:09:01 GMT+00:00\n' +
//     'Olga Pico:\n' +
//     '\n' +
//     'IT WILL WORK WITH WIFI.\n' +
//     'Confirm Network before shipping.',
//   'createdBy': null,
//   'updatedBy': null,
//   'network': {
//     'status': true,
//     'ipAddress': {
//       'isDhcp': true,
//       'ip': null,
//       'mask': null,
//       'gateway': null,
//       'dns1': '10.18.0.8',
//       'dns2': '8.8.8.8'
//     },
//     'wifi': null,
//     'proxy': {
//       'enable': false,
//       'address': null,
//       'port': 0,
//       'login': null,
//       'password': null
//     }
//   },
//   'status': 1,
//   'server': {
//     'id': 1,
//     'server': {'id': 1},
//     'ip': '192.132.1.4',
//     'url': 'https://www.sto.com',
//     'name': 'name server'
//   },
//   'closed': null,
//   'closedBy': null,
//   'licence': {
//     'id': 1,
//     'name': 'licence 1'
//   },
//   'cd': true,
//   'program': {
//     'id': 0,
//     'name': null,
//     'displayName': null
//   },
//   'screenRotation': 90,
//   'isOrderOpened': true,
//   'externalID': 'scsc',
//   'timeZone': 'Europe/Paris',
//   'deleted': false,
//   'uuid': 'bd4c2e15-f4d1-4145-83a1-499e58550409',
//   'created': '2006-01-01T01:00:00+01:00',
//   'updated': '2003-06-13T02:00:00+02:00',
//   'id': 17,
//   'name': ' Siège (Phildar)',
//   'displayName': ' Siège (Phildar)'
// }


export const DUMMY_ARRAY_RESPONSE_LICENCES = {
  'statusCode': 0,
  'message': null,
  'data': {
    'array': [
      {
        'name': 'licence 1 ' + Math.floor((Math.random() * 10000) + 3),
        'id': 1
      },
      {
        'name': 'licence 2 ' + Math.floor((Math.random() * 10000) + 3),
        'id': 2
      },
      {
        'name': 'licence 3 ' + Math.floor((Math.random() * 10000) + 3),
        'id': 3
      }
    ],
    'count': 9
  },
  'log': null,
  'version': '1.0.10.27391',
  'timeToProcess': '00:00:00.0120020',
  'cached': false
}

export const DUMMY_ARRAY_RESPONSE_PROGRAMS = {
  'statusCode': 0,
  'message': null,
  'data': {
    'array': [
      {
        'name': 'program  1 ' + Math.floor((Math.random() * 10000) + 3),
        'id': 1
      },
      {
        'name': 'program 2 ' + Math.floor((Math.random() * 10000) + 3),
        'id': 2
      },
      {
        'name': 'program 3 ' + Math.floor((Math.random() * 10000) + 3),
        'id': 3
      }
    ],
    'count': 9
  },
  'log': null,
  'version': '1.0.10.27391',
  'timeToProcess': '00:00:00.0120020',
  'cached': false
}
